<script>
  import { previews_scrolled_up, previews_scrolled_down } from '../stores'
  
  export let previews_element

  let scroll_top = 0
  let last_scroll_top = 0
  let tolerance = 40
  let limit = 400

  function checkScroll(scroll_top) {
    if (!previews_element) return
    if (Math.abs(last_scroll_top - scroll_top) <= tolerance) {
      return
    }

    if (scroll_top > last_scroll_top) {
      // Scrolling Down
      $previews_scrolled_up = false
      // Scrolling up if scrolled past limit and not at the end of page
      if(scroll_top > limit && scroll_top < previews_element.parentNode.offsetHeight + 80 - window.innerHeight) {
        $previews_scrolled_down = true
      }else{
        $previews_scrolled_down = false
      }
    } else {
      // // Scrolling Up
      if (!previews_element) return
      if(scroll_top + window.innerHeight < previews_element.offsetHeight) {
        $previews_scrolled_up = true
        $previews_scrolled_down = false
      }
      if(scroll_top < limit) {
        $previews_scrolled_up = false
      }
    }
    last_scroll_top = scroll_top

  }

  $: checkScroll(scroll_top)
</script>

<svelte:window bind:scrollY={scroll_top}/>